import TabaPayDebitCardFundingForm from 'features/moveMoney/screens/dcf/tabapay/TabapayForm/TabaPayDebitCardFundingForm';
import React from 'react';

export default function DebitCardFundingPage() {
  return <TabaPayDebitCardFundingForm />;
}
